import React from "react";

import type { JSX } from "react";

interface IIosIcon {
  className?: string;
}

function IosIcon(props: IIosIcon): JSX.Element {
  const { className } = props;
  return (
    <svg
      className={className}
      fill="currentColor"
      viewBox="60 134 580 433"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M111.861 465.433h39.755V296.195h-39.755zM131.659 274c12.453 0 22.193-9.58 22.193-21.554 0-12.134-9.74-21.714-22.193-21.714-12.294 0-22.033 9.58-22.033 21.714 0 11.975 9.74 21.554 22.033 21.554zm152.32-42.79c-67.215 0-109.367 45.823-109.367 119.108 0 73.284 42.148 118.947 109.367 118.947 67.056 0 109.208-45.663 109.208-118.947 0-73.285-42.148-119.108-109.208-119.108zm0 35.125c41.033 0 67.216 32.571 67.216 83.982 0 51.25-26.184 83.822-67.216 83.822-41.191 0-67.215-32.571-67.215-83.822 0-51.41 26.025-83.982 67.215-83.982zm125.978 134.276c1.757 42.47 36.562 68.654 89.569 68.654 55.722 0 90.848-27.462 90.848-71.209 0-34.326-19.798-53.645-66.578-64.342l-26.503-6.067c-28.26-6.706-39.915-15.646-39.915-30.974 0-19.159 17.563-31.932 43.587-31.932 26.343 0 44.383 12.933 46.3 34.487h39.277c-.958-40.554-34.487-68.017-85.257-68.017-50.134 0-85.739 27.621-85.739 68.495 0 32.89 20.118 53.327 62.585 63.067l29.856 7.025c29.058 6.865 40.873 16.445 40.873 33.05 0 19.158-19.319 32.89-47.098 32.89-28.1 0-49.333-13.891-51.888-35.126H409.96z" />
    </svg>
  );
}

export default IosIcon;
